// extracted by mini-css-extract-plugin
module.exports = {"question":"FAQItem_question__VE7J_","answer":"FAQItem_answer__u5Twm","faqItem":"FAQItem_faqItem__c8B70"};